import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const DONE_NOTE_MAX = 500;

// "<note> — <date>" for the hover on a Done label; "" when the doc carries no note
// (legacy done docs, or done set without one).
export function doneNoteText(item) {
  const note = item?.done_note;
  if (!note) return "";
  let when = "";
  if (item.done_at) {
    const d = new Date(item.done_at);
    if (!Number.isNaN(d.getTime())) when = d.toISOString().slice(0, 10);
  }
  return when ? `${note} — ${when}` : note;
}

// Confirm step for the done control. mode "done": required "Name or reason" box (trimmed,
// 1-500 chars) and a "Mark as done" button; mode "undone": plain confirm, no box.
// onConfirm(note) fires only on confirm; Cancel / close sends nothing.
export default function MarkDoneDialog({ open, mode = "done", count = 1, onConfirm, onCancel }) {
  const [note, setNote] = useState("");
  const isDone = mode === "done";
  const trimmed = note.trim();
  const valid = !isDone || (trimmed.length >= 1 && trimmed.length <= DONE_NOTE_MAX);

  useEffect(() => {
    if (open) setNote("");
  }, [open]);

  const submit = (e) => {
    e?.preventDefault?.();
    if (!valid) return;
    onConfirm(isDone ? trimmed : undefined);
  };

  const many = count > 1 ? `${count} documents` : "this document";

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="max-w-md" data-testid="mark-done-dialog">
        <form onSubmit={submit} className="grid gap-4">
          <DialogHeader>
            <DialogTitle>{isDone ? "Mark as done?" : "Mark as not done?"}</DialogTitle>
            <DialogDescription>
              {isDone
                ? `Add a name or reason for marking ${many} as done.`
                : `This clears the note on ${many}.`}
            </DialogDescription>
          </DialogHeader>
          {isDone && (
            <div className="grid gap-1.5">
              <label htmlFor="mark-done-note" className="text-sm font-medium">
                Name or reason
              </label>
              <Input
                id="mark-done-note"
                autoFocus
                value={note}
                maxLength={DONE_NOTE_MAX}
                onChange={(e) => setNote(e.target.value)}
              />
            </div>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="submit" disabled={!valid}>
              {isDone ? "Mark as done" : "Mark as not done"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
